import React from "react";
import Banner from "../../components/templates/home/Rates/Banner";
import Cards from "../../components/templates/home/Rates/Desription";

const Rates = () => {
  return (
    <div>
      <Banner />
      <Cards />
    </div>
  );
};

export default Rates;
